import styled from "styled-components";

export const StyledLayoutPage = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  gap: ${(props) => props.theme.spacing.normal};
`;
